/** 미구현 화면 공통 플레이스홀더 */
import { useNavigate } from 'react-router';
import { Button } from '@indipia/ui-core';

interface Props {
  title: string;
  spec?: string; // 상세기능정의서 화면 코드 (예: "D-1")
}

export function ComingSoonPage({ title, spec }: Props) {
  const navigate = useNavigate();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-xl bg-surface-muted">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="text-text-muted">
          <rect x="3" y="3" width="18" height="18" rx="3"/>
          <line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/>
          <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
        </svg>
      </div>
      <div>
        {spec && <p className="mb-1 text-xs font-medium text-group">{spec}</p>}
        <h1 className="text-lg font-bold text-text">{title}</h1>
        <p className="mt-1 text-sm text-text-muted">곧 만나볼 수 있어요</p>
      </div>
      <Button type="button" variant="etc" size="sm" onClick={() => navigate(-1)} className="mt-2">
        뒤로가기
      </Button>
    </div>
  );
}
